export function ExtractNodes(statesRender, statesArray, tikz) {
  const regex = /\\node\s*(.*?)\s*;/gs;
  var nodes = tikz.match(regex);
  for (let i = 0; i < nodes.length; i++) {
    statesRender = new Object();
    statesRender.state = "";
    var positionString = nodes[i].split("at ");
    statesRender.statesRef = positionString[0].match(/\(([^)]+)\)/)[1]; // para armazenar o número do estado referência
    var numCommas = (positionString[1].match(/,/g) || []).length;
    var numQ = (positionString[1].match(/q/g) || []).length;
    // TRATAR states decimais EX: {$q_{1,4}$}
    if (positionString[1].includes("q_{")) {
      statesRender.state = "";
      var posStringAux = positionString[1].split("q_{")[1].split("}")[0];
      var arrayStates = posStringAux.split(",");
      for (var n = 0; n < arrayStates.length; n++) {
        statesRender.state = statesRender.state + "Q" + arrayStates[n];
      }
    }
    if (numCommas >= 2 && numQ > 1) {
      statesRender.state = "";
      const regex = /q_(\d+)/g;
      let compoundStates = [];
      let result;
      while ((result = regex.exec(positionString[1])) !== null) {
        compoundStates.push(parseInt(result[1]));
      }
      var f = 0;
      while (numCommas != 0) {
        statesRender.state = statesRender.state + "Q" + compoundStates[f];
        f++;
        numCommas--;
      }
    } else if (statesRender.state == "") {
      statesRender.state = statesRender.statesRef;
      statesRender.statesRef = "";
    }
    const regex3 = /\[(.*?)\]/; // para obter a descrição do estado i.e final, inicial e ambos.
    statesRender.description = nodes[i].match(regex3)[1];
    const regex4 = /\((.*?)\)/; // para obter a posição do estado
    statesRender.posX = positionString[1].match(regex4)[1].split(",")[0];
    statesRender.posY = positionString[1].match(regex4)[1].split(",")[1];
    statesArray[i] = statesRender;
  }
  for (let i = 0; i < statesArray.length; i++) {
    statesArray[i].posX = parseFloat(statesArray[i].posX);
    statesArray[i].posY = parseFloat(statesArray[i].posY);
  }
  return statesArray;
}
